module.exports = __webpack_public_path__ + "img/message.136f0208.png";